/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WorkspacePortalAdmin,
    WorkspacePortalAdminFromJSON,
    WorkspacePortalAdminFromJSONTyped,
    WorkspacePortalAdminToJSON,
} from './WorkspacePortalAdmin';

/**
 * 
 * @export
 * @interface WorkspacePortalAdminsResponse
 */
export interface WorkspacePortalAdminsResponse {
    /**
     * 
     * @type {Array<WorkspacePortalAdmin>}
     * @memberof WorkspacePortalAdminsResponse
     */
    results: Array<WorkspacePortalAdmin>;
}

export function WorkspacePortalAdminsResponseFromJSON(json: any): WorkspacePortalAdminsResponse {
    return WorkspacePortalAdminsResponseFromJSONTyped(json, false);
}

export function WorkspacePortalAdminsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspacePortalAdminsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(WorkspacePortalAdminFromJSON)),
    };
}

export function WorkspacePortalAdminsResponseToJSON(value?: WorkspacePortalAdminsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(WorkspacePortalAdminToJSON)),
    };
}

